import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess204006Status: 'idle',
    startProcess204006Error: undefined as any,
    loadUserParamsProcess204006Status: 'idle',
    loadUserParamsProcess204006Error: undefined as any,

    process204006List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess204006 = createAsyncThunk('process204006Slice/startProcess204006', async ({ process204006 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess204006/`,
        prepareData(process204006),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess204006Status } = getState().process204006Slice
        return startProcess204006Status !== 'pending'
    }
})

export const loadUserParamsProcess204006 = createAsyncThunk('process204006Slice/loadUserParamsProcess204006', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess204006/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess204006Status } = getState().process204006Slice
        return loadUserParamsProcess204006Status !== 'pending'
    }
})

const Process204006Slice = createSlice({
    name: 'process204006Slice',
    initialState,
    reducers: {
        resetstartProcess204006: (state) => {
            state.job = undefined
            state.startProcess204006Error = undefined
        },
        resetstartProcess204006Error: (state) => {
            state.startProcess204006Error = undefined
        },
        resetloadUserParamsProcess204006: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess204006Error = undefined
        },
        resetloadUserParamsProcess204006Error: (state) => {
            state.loadUserParamsProcess204006Error = undefined
        },
        removeFromProcess204006ListById: (state, action) => {
            state.process204006List = state.process204006List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess204006ListByIds: (state, action) => {
            state.process204006List = state.process204006List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process204006List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess204006Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process204006List = []
            state.startProcess204006Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess204006.pending, (state) => {
            state.startProcess204006Status = 'pending'
            state.startProcess204006Error = undefined
        })
        builder.addCase(startProcess204006.fulfilled, (state, action) => {
            state.startProcess204006Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess204006.rejected, (state, action) => {
            state.startProcess204006Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess204006Error = action.error.message
            } else {
                state.startProcess204006Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess204006.pending, (state) => {
            state.loadUserParamsProcess204006Status = 'pending'
            state.loadUserParamsProcess204006Error = undefined
        })
        builder.addCase(loadUserParamsProcess204006.fulfilled, (state, action) => {
            state.loadUserParamsProcess204006Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess204006.rejected, (state, action) => {
            state.loadUserParamsProcess204006Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess204006Error = action.error.message
            } else {
                state.loadUserParamsProcess204006Error = action.payload
            }
        })

    }
})

export const {
    resetstartProcess204006,
    resetstartProcess204006Error,
    resetloadUserParamsProcess204006,
    resetloadUserParamsProcess204006Error,
    removeFromProcess204006ListById,
    removeFromProcess204006ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process204006Slice.actions
export default Process204006Slice.reducer
